module.exports = __webpack_public_path__ + "media/night/332-2c2a308f.svg";